import App from "./screens/App";

import { FluentProvider, teamsLightTheme, webLightTheme } from "@fluentui/react-components";
import { createRoot } from "react-dom/client";
import { Screen } from "../utils/common/constants";
import { attemptTokenRefresh } from "../utils/auth";
import ClientUtil from "../utils/client-util";
import { clearStorage } from "../utils/auth";
import { useEffect, useState } from "react";
import FwLoader from "./screens/Loading";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

function AppRoot() {
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState("");
  const [currentScreen, setCurrentScreen] = useState<Screen>(Screen.Login);

  async function verifyUser() {
    setLoadingText("Verifying user...");
    const isTokenValid = await attemptTokenRefresh("taskpane_load");

    if (isTokenValid) {
      setLoadingText("Finishing up. Redirecting to dashboard...");
    } else {
      setLoadingText("Verification failed. Redirecting to login...");
      clearStorage("refresh_failed_on_load");
    }

    return isTokenValid;
  }

  async function init() {
    try {
      setLoading(true);

      const isTokenValid = await verifyUser();

      setCurrentScreen(isTokenValid ? Screen.Home : Screen.Login);
    } catch (error) {
      console.error("Error while init, ", error);
    } finally {
      setLoading(false);
      setLoadingText("");
    }
  }

  useEffect(() => {
    init();
    ClientUtil.init();
  }, []);

  return <FluentProvider theme={webLightTheme}>{loading ? <FwLoader label={loadingText} /> : <App screen={currentScreen} />}</FluentProvider>;
}

/**
 * @description temp code to add backward compatibility
 * @todo remove it in next update
 */
function localStorageBackwardCompatibility() {
  const { getItem } = localStorage.__proto__;

  localStorage.getItem = function (key) {
    if (key === "baseUrl") {
      return getItem.call(this, "team");
    }
    return getItem.call(this, key);
  };
}

/* Render application after Office initializes */
Office.onReady(async () => {
  if (root) {
    localStorageBackwardCompatibility();
    root.render(<AppRoot />);
  }
});

if ((module as any).hot) {
  (module as any).hot.accept("./screens/App", async () => {
    const NextApp = (await import("./screens/App")).default as any;

    root?.render(<NextApp />);
  });
}
